export default {
  path: 'registration-signature-report',
  component: () =>
    import('@/views/dashboard/registration-signature/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'registration-signature-report',
      component: () =>
        import('@/views/dashboard/registration-signature/Main.vue'),
    }
  ],
};